import PropTypes from 'prop-types';
import * as React from 'react';
import identity from 'transmute/identity';
import getErrorTypeFromException from 'reporting-data/lib/getErrorTypeFromException';
import { ReportingLogger } from 'reporting-data/monitoring/reportingLogger';
// @ts-expect-error Untyped dependency
import ErrorMessageComponent from '../../components/shared/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const NEW_RELIC_ERROR_BOUNDARY_ACTION = 'ErrorBoundaryReportingError';
export class ErrorBoundary extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false,
      error: undefined
    };
    this.componentDidUpdate = previousProps => {
      if (previousProps.report !== this.props.report) {
        this.setState({
          hasError: false,
          error: undefined
        });
      }
    };
    this.componentDidCatch = error => {
      const {
        report,
        onError,
        errorBoundaryName
      } = this.props;
      if (report) {
        const reportingLogger = new ReportingLogger();
        reportingLogger.addReportAttributes(report);
        if (errorBoundaryName) {
          reportingLogger.logError(error, errorBoundaryName, NEW_RELIC_ERROR_BOUNDARY_ACTION);
        } else {
          reportingLogger.logError(error, 'component', NEW_RELIC_ERROR_BOUNDARY_ACTION);
        }
      }
      if (onError) {
        onError(error);
      }
    };
    this.render = () => {
      const {
        ErrorComponent,
        children
      } = this.props;
      const {
        hasError,
        error
      } = this.state;
      if (hasError) {
        const Component = ErrorComponent || ErrorMessageComponent;
        return /*#__PURE__*/_jsx(Component, {
          error: error,
          type: getErrorTypeFromException(error)
        });
      }
      return children;
    };
  }
}
ErrorBoundary.propTypes = {
  report: PropTypes.any,
  children: PropTypes.node,
  onError: PropTypes.func,
  ErrorComponent: PropTypes.elementType,
  errorBoundaryName: PropTypes.string
};
ErrorBoundary.defaultProps = {
  errorBoundaryName: '',
  children: null,
  onError: identity
};
ErrorBoundary.getDerivedStateFromError = error => ({
  hasError: true,
  error
});
const ErrorBoundaryDecorator = (Component, errorBoundaryName) => {
  return props => /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({
    errorBoundaryName
  }, props, {
    children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
  }));
};
export default ErrorBoundaryDecorator;